/**
 * NS Investigation detail
 */

export const NS_GET_INVEST_DETAIL_DATA = 'NS_GET_INVEST_DETAIL_DATA';
export const NS_GET_INVEST_DETAIL_DATA_SUCCESS =
  'NS_GET_INVEST_DETAIL_DATA_SUCCESS';
export const NS_GET_INVEST_DETAIL_DATA_FAIL = 'NS_GET_INVEST_DETAIL_DATA_FAIL';

export const NS_GET_INVEST_DETAIL_HIT_DATA = 'NS_GET_INVEST_DETAIL_HIT_DATA';
export const NS_GET_INVEST_DETAIL_HIT_DATA_SUCCESS =
  'NS_GET_INVEST_DETAIL_HIT_DATA_SUCCESS';
export const NS_GET_INVEST_DETAIL_HIT_DATA_FAIL =
  'NS_GET_INVEST_DETAIL_HIT_DATA_FAIL';

export const NS_GET_INVEST_DETAIL_PASTHITS_DATA =
  'NS_GET_INVEST_DETAIL_PASTHITS_DATA';
export const NS_GET_INVEST_DETAIL_PASTHITS_DATA_SUCCESS =
  'NS_GET_INVEST_DETAIL_PASTHITS_DATA_SUCCESS';
export const NS_GET_INVEST_DETAIL_PASTHITS_DATA_FAIL =
  'NS_GET_INVEST_DETAIL_PASTHITS_DATA_FAIL';

export const NS_RESET_INVEST_DETAIL_DATA = 'NS_RESET_INVEST_DETAIL_DATA';
export const NS_RESET_INVEST_DETAIL_PASTHITS_DATA =
  'NS_RESET_INVEST_DETAIL_PASTHITS_DATA';

export const getInvestDetailPastHitsData = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_PASTHITS_DATA,
    payload
  };
};

export const getInvestDetailPastHitsDataSuccess = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_PASTHITS_DATA_SUCCESS,
    payload
  };
};

export const getInvestDetailPastHitsDataFail = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_PASTHITS_DATA_FAIL,
    payload
  };
};

export const resetInvestDetailPastHitsData = (payload) => {
  return {
    type: NS_RESET_INVEST_DETAIL_PASTHITS_DATA,
    payload
  };
};

export const getInvestDetailHitData = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_HIT_DATA,
    payload
  };
};

export const getInvestDetailHitDataSuccess = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_HIT_DATA_SUCCESS,
    payload
  };
};

export const getInvestDetailHitDataFail = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_HIT_DATA_FAIL,
    payload
  };
};

export const getInvestDetailData = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_DATA,
    payload
  };
};

export const getInvestDetailDataSuccess = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_DATA_SUCCESS,
    payload
  };
};

export const getInvestDetailDataFail = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_DATA_FAIL,
    payload
  };
};

export const updateHitInfo = (payload) => {
  return {
    type: NS_GET_INVEST_DETAIL_DATA,
    payload
  };
};

export const resetInvestDetailData = (payload) => {
  return {
    type: NS_RESET_INVEST_DETAIL_DATA,
    payload
  };
};
